export default __webpack_public_path__ + "static/media/arrowRightWhite.d203ec2b.svg";